import React from "react";
import { Container, Typography, Box } from "@mui/material";

const ContactUs = () => (
  <Container sx={{ mt: 4 }}>
    <Typography variant="h4" gutterBottom>Contact Us</Typography>

    <Typography variant="body1" paragraph>
      If you have any questions, feedback, or issues, our support team is here to help.
    </Typography>

    <Box sx={{ mt: 2 }}>
      <Typography variant="h6">📧 Email</Typography>
      <Typography variant="body1">support@hphttech.com</Typography>

      <Typography variant="h6" sx={{ mt: 2 }}>📍 Mailing Address</Typography>
      <Typography variant="body1">
        HPHT Technology Sdn Bhd<br />
        39 Jalan Teluk Kumbar,<br />
        Teluk Kumar, 11920 Penang, Malaysia
      </Typography>

      <Typography variant="h6" sx={{ mt: 2 }}>📱 WhatsApp Support</Typography>
      <Typography variant="body1">
        <a href="https://wa.me/60164709459" target="_blank" rel="noopener noreferrer">
          +6016-4709459
        </a>
      </Typography>
    </Box>
  </Container>
);

export default ContactUs;